import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import useUser from 'shared/hooks/use-user';
import { WEBSITE_API } from '../api/website-api';
import { WebsiteListApiInterface } from '../types/website-interface';
export const useWebsites = () => {
  const $ = _c(10);
  const {
    user
  } = useUser();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && [`${WEBSITE_API}/websites?page=1&itemsPerPage=50`, RequestModuleEnum.Websites];
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: websites,
    mutate
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== revalidateModules) {
    t2 = async hardRevalidate => {
      await revalidateModules([RequestModuleEnum.Websites], hardRevalidate);
    };
    $[3] = revalidateModules;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const revalidateWebsiteModule = t2;
  let t3;
  if ($[5] !== isFetching || $[6] !== mutate || $[7] !== revalidateWebsiteModule || $[8] !== websites) {
    t3 = {
      websites,
      mutate,
      revalidateWebsiteModule,
      isFetching
    };
    $[5] = isFetching;
    $[6] = mutate;
    $[7] = revalidateWebsiteModule;
    $[8] = websites;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};